import { EmployeePaymentMethodStatus } from '@zorro/clients';
import { Button } from '@zorro/design-system/v2/Button';
import { useAppRouter, useMonolithQuery } from '@zorro/web/ui-utils';

import { CarrierApplicationModalStepType } from '../../../../CarrierApplicationFlow';
import { EnrollmentAction } from '../../../EmployeePageHeader';

type Props = {
  employeeId: string;
  onboardingPeriodId: string;
  onEnrollmentTabActionChange: (action?: EnrollmentAction) => void;
};

export const EnrollmentPaymentMethod = ({
  employeeId,
  onboardingPeriodId,
  onEnrollmentTabActionChange,
}: Props) => {
  const { navigateToRouteAsync } = useAppRouter();

  const { data: paymentMethod, isLoading: isLoadingPaymentMethod } =
    useMonolithQuery({
      method: 'paymentsControllerGetPaymentMethod',
      params: [employeeId, onboardingPeriodId],
    });

  const { data: employee, isLoading: isLoadingEmployee } = useMonolithQuery({
    method: 'employeesControllerFindOne',
    params: [employeeId],
  });

  const { data: benefits, isLoading: isLoadingBenefits } = useMonolithQuery({
    method: 'benefitsControllerGetBenefits',
    params: [onboardingPeriodId],
  });

  const benefitId = benefits?.majorMedicalBenefit?.id;

  if (
    isLoadingPaymentMethod ||
    isLoadingEmployee ||
    isLoadingBenefits ||
    !paymentMethod ||
    !employee ||
    !benefitId
  ) {
    return null;
  }

  if (paymentMethod.status !== EmployeePaymentMethodStatus.EMPTY) {
    return null;
  }

  const handleOpenCarrierAppPaymentStep = async () => {
    await navigateToRouteAsync(
      'OPS_EMPLOYEE_ZORRO_PAY_TAB',
      [{ onboardingPeriodId, employerId: employee.employerId, employeeId }],
      {
        step: CarrierApplicationModalStepType.PAYMENT_METHOD,
        benefitId,
      }
    );
    onEnrollmentTabActionChange(EnrollmentAction.CARRIER_APPLICATION);
  };

  return (
    <Button variant="tertiary" onClick={handleOpenCarrierAppPaymentStep}>
      Generate payment method
    </Button>
  );
};
